// extracted by mini-css-extract-plugin
export default {"modalBox":"ModalAddFacility_modalBox__LhUti","title":"ModalAddFacility_title__Lad2s","description":"ModalAddFacility_description__DVs2l","control":"ModalAddFacility_control__WBSQP"};